import TabletCharacterImage from "@/components/TabletCharacterImage.vue";
import SAMPLE_URL from "@/const/samplePictUrl.js";

const BACK_SYMBOL_DATA_URL = "data:image/gif;base64,R0lGODlhAQABAGAAACH5BAEKAP8ALAAAAAABAAEAAAgEAP8FBAA7";

const FRONT_PAYLOADS = {
  underCharactersPayload: {
    itemName: "位表記",
    itemKey: "underCharacters",
    columnIndex: null,
  },
  secularNamePayload: {
    itemName: "俗名",
    itemKey: "secularName",
    columnIndex: null,
  },
  secularNamePrefixPayload: {
    itemName: "俗名表記",
    itemKey: "secularNamePrefix",
    columnIndex: null,
  },
  diedCharacterPayload: {
    itemName: "没表記",
    itemKey: "diedCharacter",
    columnIndex: null,
  },
  buddhistNamePayload: {
    itemName: "戒名",
    itemKey: "buddhistName",
    columnIndex: null,
  },
  dateOfDeathYearPayload: {
    itemName: "没年月日(年)",
    itemKey: "dateOfDeathYear",
    columnIndex: null,
  },
  dateOfDeathMonthPayload: {
    itemName: "没年月日(月)",
    itemKey: "dateOfDeathMonth",
    columnIndex: null,
  },
  dateOfDeathDayPayload: {
    itemName: "没年月日(日)",
    itemKey: "dateOfDeathDay",
    columnIndex: null,
  },
  ageAtDeathPrefixPayload: {
    itemName: "享年表記",
    itemKey: "ageAtDeathPrefix",
    columnIndex: null,
  },
  ageAtDeathPayload: {
    itemName: "没年齢",
    itemKey: "ageAtDeath",
    columnIndex: null,
  },
  ageUnitCharacterPayload: {
    itemName: "年齢単位",
    itemKey: "ageUnitCharacter",
    columnIndex: null,
  },
  hostNameCharacterPayload: {
    itemName: "施主",
    itemKey: "hostName",
    columnIndex: null,
  },
};

const BACK_PAYLOADS = {
  ageAtDeathPrefixPayload: {
    itemName: "享年表記",
    itemKey: "ageAtDeathPrefix",
    columnIndex: null,
  },
  ageAtDeathPayload: {
    itemName: "没年齢",
    itemKey: "ageAtDeath",
    columnIndex: null,
  },
  diedCharacterPayload: {
    itemName: "没表記",
    itemKey: "diedCharacter",
    columnIndex: null,
  },
  /*
  dateOfDeathPayload: {
    itemName: "没年月日",
    itemKey: "dateOfDeath",
    columnIndex: null
  },
  */
  dateOfDeathYearPayload: {
    itemName: "没年月日(年)",
    itemKey: "dateOfDeathYear",
    columnIndex: null,
  },
  dateOfDeathMonthPayload: {
    itemName: "没年月日(月)",
    itemKey: "dateOfDeathMonth",
    columnIndex: null,
  },
  dateOfDeathDayPayload: {
    itemName: "没年月日(日)",
    itemKey: "dateOfDeathDay",
    columnIndex: null,
  },
  ageUnitCharacterPayload: {
    itemName: "年齢単位",
    itemKey: "ageUnitCharacter",
    columnIndex: null,
  },
  secularNamePayload: {
    itemName: "俗名",
    itemKey: "secularName",
    columnIndex: null,
  },
  secularNamePrefixPayload: {
    itemName: "俗名表記",
    itemKey: "secularNamePrefix",
    columnIndex: null,
  },
};

// for Component
// Layout.id からコンポーネント名を生成し <component> に利用する
// ColorSample と Layout 用の components: {...} の記述までここに入れても良さそうだが４パターン用意する必要がある（import 時の名称の管理が面倒になる）
const component = {
  props: {
    detail: {
      type: Object,
      required: true,
    },
  },
  computed: {
    computedComponentName: function () {
      const capitalizeFn = (str, index) => {
        if (
          typeof str !== "string" ||
          !str
        ) {
          return str;
        }

        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
      };

      // 状態の復元を含めた形で layout を取得
      const { layout } = this.detail || this.$store.state.orderForm.orderTypeInput;

      // layout がなかった場合は初期地として空の id を指定
      // この処理がないと主にカラーサンプルで「作成を中止」した際にエラーとなる
      const id = layout ? layout.id : "";
      const componentName = id.split("-")
        .map((str, index) => {
          return capitalizeFn(str, index);
        })
        .join("");

      return componentName;
    },
  },
};

// for Front
// 位牌の表、戒名や没年月日などの入力に対して処理を行う
const front = {
  components: {
    TabletCharacterImage,
  },
  props: {
    // detail: {
    //   type: Object,
    //   required: true,
    // },
    columns: {
      type: Array,
      default: () => [],
    },
    typography: {
      type: Object,
      default: () => ({}),
    },
    sanskritCharacterOrFamilyEmblem: {
      type: String,
      default: "",
    },
    sanskritCharacter: {
      type: Object,
      default: () => ({}),
    },
    customSanskritCharacterUrl: {
      type: String,
      default: "",
    },
    familyEmblem: {
      type: Object,
      default: () => ({}),
    },
    customFamilyEmblemUrl: {
      type: String,
      default: "",
    },
    secularNamePrefix: {
      type: Array,
      default: () => [],
    },
    underCharacters: {
      type: Array,
      default: () => [],
    },
    underCharactersPlacement: {
      type: String,
      default: "",
    },
    ageUnitCharacter: {
      type: Array,
      default: () => [],
    },
    ageAtDeathPrefix: {
      type: Array,
      default: () => [],
    },
    ageAtDeathPrefixPlacement: {
      type: String,
      default: "",
    },
    diedCharacter: {
      type: Array,
      default: () => [],
    },
    hostName: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      SAMPLE_URL,
      ...FRONT_PAYLOADS,
    };
  },
  computed: {
    isSymbolAvailable () {
      const {
        customFamilyEmblemUrl,
        customSanskritCharacterUrl,
        sanskritCharacterOrFamilyEmblem,
        sanskritCharacter,
        familyEmblem,
      } = this;

      if (sanskritCharacterOrFamilyEmblem === "SANSKRIT_CHARACTER") {
        if (customSanskritCharacterUrl) {
          return true;
        }
        // 梵字を表示
        return sanskritCharacter && sanskritCharacter.imageUrlForTablet;
      }

      if (sanskritCharacterOrFamilyEmblem === "FAMILY_EMBLEM") {
        if (customFamilyEmblemUrl) {
          return true;
        }
        // 家紋を表示
        return familyEmblem && familyEmblem.imageUrlForTablet;
      }

      return false;
    },

    computedSymbolSrc () {
      const {
        sanskritCharacterOrFamilyEmblem,
        customSanskritCharacterUrl,
        sanskritCharacter,
        customFamilyEmblemUrl,
        familyEmblem,
      } = this;

      // 梵字
      if (sanskritCharacterOrFamilyEmblem === "SANSKRIT_CHARACTER") {
        return customSanskritCharacterUrl
          ? SAMPLE_URL.URLHead + SAMPLE_URL.SANSKRIT_CHARACTER
          : sanskritCharacter.imageUrlForTablet;
      }

      // 家紋
      return customFamilyEmblemUrl
        ? SAMPLE_URL.URLHead + SAMPLE_URL.FAMILY_EMBLEM
        : familyEmblem.imageUrlForTablet;
    },
  },
};

// for Back
// 位牌の裏、戒名や没年月日などの入力に対して処理を行う
const back = {
  components: {
    TabletCharacterImage,
  },
  props: {
    // detail: {
    //   type: Object,
    //   required: true,
    // },
    columns: {
      type: Array,
      default: () => [],
    },
    typography: {
      type: Object,
      default: () => ({}),
    },
    isSanskritCharacterBackNeeded: {
      type: Boolean,
      default: false,
    },
    sanskritCharacterBack: {
      type: Object,
      default: () => ({}),
    },
    customSanskritCharacterBackUrl: {
      type: String,
      default: "",
    },
    secularNamePrefix: {
      type: Array,
      default: () => [],
    },
    secularNamePrefixPlacement: {
      type: String,
      default: "",
    },
    ageUnitCharacter: {
      type: Array,
      default: () => [],
    },
    ageAtDeathPrefix: {
      type: Array,
      default: () => [],
    },
    ageAtDeathPrefixPlacement: {
      type: String,
      default: "",
    },
    diedCharacter: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      SAMPLE_URL,
      ...BACK_PAYLOADS,
    };
  },
  computed: {
    isBackSymbolAvailable () {
      const {
        isSanskritCharacterBackNeeded,
        customSanskritCharacterBackUrl,
        sanskritCharacterBack,
      } = this;

      if (isSanskritCharacterBackNeeded) {
        if (customSanskritCharacterBackUrl) {
          return true;
        }
        // 梵字を表示
        return sanskritCharacterBack && sanskritCharacterBack.imageUrlForTablet;
      }

      return false;
    },

    computedBackSymbolSrc () {
      const fetchBackSymbolSrcFn = (url) => {
        return url || BACK_SYMBOL_DATA_URL;
      };

      const {
        customSanskritCharacterBackUrl,
        sanskritCharacterBack,
      } = this;

      // 裏梵字
      return customSanskritCharacterBackUrl
        ? SAMPLE_URL.URLHead + SAMPLE_URL.SANSKRIT_CHARACTER
        : fetchBackSymbolSrcFn(sanskritCharacterBack.imageUrlForTablet);
    },
  },
};

// for Character
// 主に文字色についての利用
const character = {
  props: {
    characterColor: {
      type: Object,
      default: () => ({ name: "白", colorCode: "white" }),
    },
  },
  computed: {
    computedCharacterColorClass () {
      return this.fetchCharacterColorClassByColorName(this.characterColor.name);
    },
  },
  methods: {
    /**
     * [fetchCharacterColorClassByColorName description]
     * @param   {[type]}  colorName  [colorName description]
     * @return  {[type]}             [return description]
     */
    fetchCharacterColorClassByColorName (colorName) {
      if (colorName === "金色") {
        return "character-yellow";
      } else if (colorName === "金箔") {
        return "character-gold";
      } else if (colorName === "朱色") {
        return "character-red";
      } else if (colorName === "黒色") {
        return "character-black";
      }
      return "character-white";
    },

    /**
     * [onClickCharacter description]
     * @param   {[type]}  payload  [payload description]
     */
    onClickCharacter (payload) {
      // payload の値は front, back で定義されているものが利用される
      this.$emit("onClickCharacter", { faceIndex: 0, ...payload });
    },
  },
};

export default {
  component,
  front,
  back,
  character,
};
